module.exports = __webpack_public_path__ + "static/media/notification-sound.448dbb5b.mp3";